export const KNOWN_AGENT_SCOPES = ['organization', 'project', 'system'];
export const AgentScope = {
    Organization: 'organization',
    Project: 'project',
    System: 'system',
};
export const KNOWN_AGENT_TEMPLATE_SCOPES = [AgentScope.Organization, AgentScope.Project];
export const KNOWN_AGENT_STATUSES = ['active', 'archived'];
export const AgentStatus = {
    Active: 'active',
    Archived: 'archived',
};
export const KNOWN_AGENT_AUTONOMY_MODES = ['approval_required', 'notify_only', 'autonomous'];
export const AgentAutonomyMode = {
    ApprovalRequired: 'approval_required',
    Autonomous: 'autonomous',
    NotifyOnly: 'notify_only',
};
export const AgentAutonomyModeCatalogId = {
    ApprovalRequired: 'autonomy.agent.approval_required',
    Autonomous: 'autonomy.agent.autonomous',
    NotifyOnly: 'autonomy.agent.notify_only',
};
/**
 * The delegation mode an Agent declares for a Conversation that has no delegation setting of its own: `off`
 * (delegation stays off until a person turns it on) or `crew_default` (the Agent's declared delegation budget over
 * the platform default). It is read only for the Agent a delegation tree's root Conversation talks to.
 */
export const KNOWN_AGENT_DEFAULT_CONVERSATION_DELEGATION_MODES = ['off', 'crew_default'];
export const AgentDefaultConversationDelegationMode = {
    Off: 'off',
    CrewDefault: 'crew_default',
};
export const KNOWN_AGENT_SKILL_BINDING_KINDS = ['system', 'tenant'];
export const AgentSkillBindingKind = {
    System: 'system',
    Tenant: 'tenant',
};
export const DEFAULT_AGENT_STATUS = AgentStatus.Active;
export const DEFAULT_AGENT_SKILL_BINDING_KIND = AgentSkillBindingKind.Tenant;
export const SYSTEM_AGENT_CATALOG_FAMILY = 'system_agent';
/**
 * The shared Crewstack product agent: one global catalog identity (never a tenant-owned copy),
 * addressed in organization and project conversations. Core resolves ordinary chat to it;
 * the frontend draws it with the brand mark rather than an id-seeded one.
 */
export const CREWSTACK_SYSTEM_AGENT_ID = 'agent.system.crewstack';
//# sourceMappingURL=vocabulary.js.map